module.exports = __webpack_public_path__ + "b91c980dced4684efb62fd406d810292.png";